module.exports = __webpack_public_path__ + "img/Step05a.c2561759.webp";